import React, { useEffect } from 'react'
import classes from './signup.module.css'
import classNames from 'classnames'
import loginImage from '../../assets/images/Login.jpg'
import logo from '../../assets/images/new-logo.png'
import { ReactComponent as ArrowRight } from '../../assets/icons/arrow-right.svg'
import { ValidatedLoginInput } from '../../components/Form/Inputs/Inputs'
import { Button, ButtonIcon } from '../../components/Button/Button'
import { Link, useLocation } from 'react-router-dom'
import { getParentRoute } from '../../util/functions'
import useAuthForm from '../../hooks/useAuthForm'
import { signUp } from '../../api/authApi'
import { useDispatch, useSelector } from 'react-redux'
import { SignUpSchema } from '../../util/formSchemas'
import { Formik } from 'formik'
import { UserTypes } from '../../util/constants'
import { startWizard } from '../Wizard/wizardLogic'
import { cartSelectors } from '../Cart/cartSlice'

const SignUp = ({ location, history }) => {
    const path = getParentRoute(location.pathname)
    const itemDetails = useSelector(cartSelectors.cartItemDetails)
    const isCartAvailable = Object.keys(itemDetails)?.length > 0
    const dispatch = useDispatch()
    const { search } = useLocation()
    const params = new URLSearchParams(search)
    const isBeneficiary = params.get('isbeneficiary')

    useAuthForm(async () => {
        if (isBeneficiary) {
            history.push(`/app/my-classes`)
            return
        }
        history.push(isCartAvailable ? '/app/cart' : startWizard())
    }, true)

    const submitForm = values => {
        //Show loader
        dispatch(signUp(values, UserTypes.Personal))
    }

    return (
        <div className={classes.container}>
            <Formik
                initialValues={{
                    firstname: '',
                    lastname: '',
                    email: '',
                    password: '',
                    confirmPassword: '',
                    jobTitle: '',
                    phonenumber: '',
                }}
                onSubmit={submitForm}
                validationSchema={SignUpSchema}
            >
                {({ handleSubmit }) => (
                    <div className={classes.form}>
                        <img
                            src={logo}
                            alt="Logo"
                            className={classes.formLogo}
                            onClick={() => history.push('/')}
                        />
                        <h1 className={classes.formHeader}>
                            Sign up to start learning (Solopreneur)
                        </h1>
                        <div className={classes.formInputs}>
                            <div className={classes.formRow}>
                                <ValidatedLoginInput
                                    placeholder={'First Name'}
                                    name={'firstname'}
                                />
                                <ValidatedLoginInput
                                    placeholder={'Last Name'}
                                    name={'lastname'}
                                />
                            </div>
                            <ValidatedLoginInput
                                placeholder={'Email Address'}
                                name={'email'}
                            />
                            <ValidatedLoginInput
                                placeholder={'Phone Number'}
                                name={'phonenumber'}
                            />
                            <ValidatedLoginInput
                                placeholder={'Your Password'}
                                name={'password'}
                                type={'password'}
                            />
                            <ValidatedLoginInput
                                placeholder={'Confirm Password'}
                                name={'confirmPassword'}
                                type={'password'}
                            />
                        </div>
                        <Button
                            className={classes.formButton}
                            bold={false}
                            onClick={handleSubmit}
                        >
                            Get Started
                            <ButtonIcon icon={<ArrowRight />} />
                        </Button>
                        <span className={classes.formSplitLine} />
                        <p className={classes.formSignInText}>
                            Already have an account?{' '}
                            <Link
                                to={`${path}/sign-in`}
                                className={classes.formSignInTextOrange}
                            >
                                Sign In
                            </Link>
                        </p>
                        <p className={classes.formSignInText}>
                            Are you a business user?{' '}
                            <Link
                                to={`/app/business/sign-up`}
                                className={classes.formSignInTextOrange}
                            >
                                Sign Up Here
                            </Link>
                        </p>
                    </div>
                )}
            </Formik>
            <img
                src={loginImage}
                alt="Login Page Background"
                className={classes.displayImage}
            />
        </div>
    )
}

export default SignUp
